export type { OtherPointsSectionProps } from "./other-points-section";
export { OtherPointsSection } from "./other-points-section";
